export default __webpack_public_path__ + "83a0f151329901dc9a0708b74d51bd6b.png";